var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMultiplePatients = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 11.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.331 12.935a34.3 34.3 0 0 1 3.25-1.293c.608-.226.509-1.815.239-2.111A4.49 4.49 0 0 1 4.651 6.05 2.934 2.934 0 0 1 7.5 2.835a2.934 2.934 0 0 1 2.849 3.215A4.49 4.49 0 0 1 9.18 9.531c-.27.3-.369 1.885.239 2.111a34.3 34.3 0 0 1 3.25 1.293"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 1.5a7.5 7.5 0 0 1 6.968 10.28 7.516 7.516 0 0 0-4.936 4.44A7.5 7.5 0 1 1 9.5 1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.331 14.435a34.3 34.3 0 0 1 3.25-1.293c.608-.226.509-1.815.239-2.111A4.49 4.49 0 0 1 6.651 7.55 2.934 2.934 0 0 1 9.5 4.335a2.934 2.934 0 0 1 2.849 3.215 4.49 4.49 0 0 1-1.169 3.481c-.27.3-.369 1.885.239 2.111 1.105.375 1.105.375 1.551.634"
})))));
export { SvgIconMultiplePatients as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-multiple-patients.svg";